import { combineReducers } from 'redux';
import balancesReducer from './balances';
import leaderboardReducer from './leaderboard';
import ledgerReducer from './ledger';
import streamerReducer from './streamer';

// the default export is the reducer, which shapes the state
const reducer = combineReducers({
  balances: balancesReducer,
  leaderboard: leaderboardReducer,
  ledger: ledgerReducer,
  streamer: streamerReducer,
});

export default reducer;
